import React, { Component } from "react";
import axios from 'axios';
import api from '../common/api';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import { Container, Row, Col } from "shards-react";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ConfirmDialog from '../common/ConfirmDialog'
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Tooltip from '@material-ui/core/Tooltip';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem'
  }
});


class MaintenancePlan extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {
						maintenance_plan:{name:'', description:'', tasks:[{task:{id:'', name:''}}]},
						snackbar:{open:false},
						tasks:{task:{}, loading: false, options:[]},
					 	loading: true,
					 	disabled: false,
					    dialog: {open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
					    delete_dialog: {open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
					    cancel_dialog: {open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
					 }
  	}

    async componentDidMount() {
		var params = this.getParams();
		if (params.id !== undefined){
			await this.getMaintenancePlan(params.id)
		}
		var disabled = (params.view === '1') ? true : false
    	this.setState({loading: false, disabled: disabled})
    }

	getParams(){
		return this.props.match.params
	}

    getMaintenancePlan = (id) => {
		const token = localStorage.getItem('userToken')
		return axios
	     .get(api.maintenance_plans().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		if (res.data.tasks.length === 0){
	      			res.data.tasks = [{task_id:'', task:{id:''}}]
	      		}
	      		this.setState({maintenance_plan: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    
    }

    handleChange = (e) => {
    	var maintenance_plan = this.state.maintenance_plan
    	if (e.target.name === 'name' || e.target.name ==='description'){
	    	maintenance_plan[e.target.name] = e.target.value
    	} else  {
			var element = e.target.name.split('.')
			var key = element[0]
			var id = element[1]
			if (key === 'task_id'){
				maintenance_plan.tasks.push({task_id:'', task:{}})
			}
			maintenance_plan.tasks[id][key] = e.target.value

    	}
    	this.setState({maintenance_plan: maintenance_plan})
    }


    handleSubmit = () => {
	    var formData = new FormData();
  		var dialog = this.state.dialog
	    var url = api.maintenance_plans().post();
	    if  (this.state.maintenance_plan.id !== undefined){
	    	url = api.maintenance_plans().patch(this.state.maintenance_plan.id);
		    formData.set("_method", 'PATCH');
		    formData.set("maintenance_plan[id]", this.state.maintenance_plan.id);
	    }
	    formData.set("maintenance_plan[name]", (this.state.maintenance_plan.name) ? this.state.maintenance_plan.name : '')
	    formData.set("maintenance_plan[description]", (this.state.maintenance_plan.description) ? this.state.maintenance_plan.description : '')
	    this.state.maintenance_plan.tasks.map((val,idx)=>{
		    	if (val.task.id !== undefined){
		    		if (val.id !== undefined){
					    formData.set("tasks["+idx+"][id]", (val.id) ? val.id : '')
		    		}
			    formData.set("tasks["+idx+"][task_id]", (val.task.id) ? val.task.id : '')
			    formData.set("tasks["+idx+"][up_to_km]", (val.up_to_km) ? val.up_to_km : '')
			    formData.set("tasks["+idx+"][each_km]", (val.each_km) ? val.each_km : '')
			    formData.set("tasks["+idx+"][months]", (val.months) ? val.months : '')
			    formData.set("tasks["+idx+"][each_months]", (val.each_months) ? val.each_months : '')
			    formData.set("tasks["+idx+"][q_alerts]", (val.q_alerts) ? val.q_alerts : '')
			    formData.set("tasks["+idx+"][days_between_alert]", (val.days_between_alert) ? val.days_between_alert : '')
			    formData.set("tasks["+idx+"][km_before_alerts]", (val.km_before_alerts) ? val.km_before_alerts : '')
			    formData.set("tasks["+idx+"][days_before_alerts]", (val.days_before_alerts) ? val.days_before_alerts : '')
	    	}
	    })
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(url,
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		dialog.title = 'Plan de mantenimiento'
		  		dialog.open = 1
		  		dialog.success = 1
		  		dialog.message = 'Se ha creado con éxito!'
		  		self.setState({dialog: dialog})

	      })
	      .catch(function (error) {
//	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
	      		var error_message = ''
	      		var errors = error.response.data
				if (errors.errors){
					if (errors.errors.status_code !== 404){
					  var keys = Object.keys(errors.errors); 
					  for(var i = 0; i < keys.length; i++) {   
					    var key = (keys[i]) ; 
					    var key_errors = errors.errors[key]
					    key_errors.map((val,idx)=>{
					      error_message = error_message.concat(val).concat(' ')
					    })
					  }
					} else {
				      error_message = error_message.concat(error.message).concat(' ')
					}
				} else {
					error_message = 'Ha ocurrido un error. Contacte a su administrador'
				}

	      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
		  		self.setState({ snackbar: snackbar})
	    })
    }

    handleSnackbar = () => {
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

	handleNewTask = (e) => {
		e.preventDefault()
		var maintenance_plan = this.state.maintenance_plan
		maintenance_plan.tasks.push({task_id:'', 'up_to_km': '', months: '', each_km:'', q_alerts:'', days_between_alert:'',km_before_alerts:'', days_before_alerts:'',task:{id:''}})
		var tasks = {task:{}, loading: false, options:[]}
		this.setState({maintenance_plan: maintenance_plan, tasks: tasks})
	}

	handleRemoveTask = (e,id) => {
		e.preventDefault()
		var delete_dialog = this.state.delete_dialog
		delete_dialog.title = 'Tareas del plan de mantenimiento'
		delete_dialog.success = 0
		delete_dialog.message = 'Esta seguro de eliminar la tarea?'
		delete_dialog.open = true
		this.setState({delete_dialog: delete_dialog, delete_id: id})
	}

	handleDelete = async () => {
		var id = this.state.delete_id
		var tasks = this.state.maintenance_plan.tasks
		var dialog = this.state.dialog
		var task = {}
		tasks.map((val,idx)=>{
		    if (idx === id){
		      task = val
		    }
		})
		if (task.id !== undefined){
		  let self = this
		  const token = localStorage.getItem('userToken')
		  await axios.delete(api.maintenance_plans().delete_task(task.id),{ headers: {"Authorization" : `Bearer ${token}`}},
		      )
		    .then((response)=> {
		      tasks = tasks.filter((s, sidx) => id !== sidx);
		      dialog.title = 'Tareas del plan de mantenimiento'
		      dialog.success = 1
		      dialog.open = true
		      dialog.message = 'Tarea eliminada con éxito!'
		    })
		    .catch(function (error) {
		      dialog.title = 'Tareas del plan de mantenimiento'
		      dialog.success = 1
		      dialog.open = true
		      dialog.message = 'Ha ocurrido al eliminar la tarea. Contact a su administrador!'
		      self.setState({dialog: dialog})
		      console.log(error)
		    })
		} else {
		  dialog.title = 'Tareas del plan de mantenimiento'
		  dialog.success = 1
		  dialog.open = true
		  dialog.message = 'Tarea eliminada con éxito!'
		  tasks = tasks.filter((s, sidx) => id !== sidx);
		}
		this.setState({tasks: tasks, dialog: dialog})
	}

    handleTasksAsyncChange = (event, values) =>{
    	var maintenance_plan = this.state.maintenance_plan
    	var task = (values !== null) ? {task:values} : {task:{id:'', name:''}}
    	var id = maintenance_plan.tasks.length -1
    	maintenance_plan.tasks[id].task = task.task
    	this.setState({maintenance_plan: maintenance_plan})
    }

    handleTasksAsyncSearch = (event, values) =>{
    	var task = values
		const token = localStorage.getItem('userToken')
		if (task.length > 3)	 {
			return axios
		     .get(api.work_order().tasks_autocomplete(task),{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		      		var tasks = this.state.tasks
		      		tasks.options = res.data
		      		this.setState({tasks: tasks})
		      })
		      .catch(err =>{console.log(err)
		      })
		}
    }

  	handleDialogClose = () => {
  		var dialog = this.state.dialog
  		dialog.open = false
  		dialog.errors = []
  		var delete_dialog = this.state.delete_dialog
  		delete_dialog.open = false
  		delete_dialog.errors = []
  		var cancel_dialog = this.state.cancel_dialog
  		cancel_dialog.open = false
  		cancel_dialog.errors = []

  		this.setState({dialog: dialog, delete_dialog:delete_dialog, cancel_dialog:cancel_dialog})
  	}

  	handleDialogAccept = () =>{
	    window.location.href='/maintenance-plans'
  	}

  	handleDialogCancel = () =>{
		this.handleDialogClose()
  	}

  	handleCancelDialog = () => {
  		var cancel_dialog = this.state.cancel_dialog
  		cancel_dialog.open = true
  		cancel_dialog.title = 'Plan de mantenimiento'
  		cancel_dialog.message = '¿Esta seguro de salir?'
  		this.setState({cancel_dialog:cancel_dialog})

  	}

	render() {
		const classes = this.props.classes;
		const maintenance_plan = this.state.maintenance_plan
		const disabled = this.state.disabled
		return (
			<React.Fragment>
				<Snackbar open={this.state.snackbar.open} autoHideDuration={10000} onClose={this.handleSnackbar}>
					<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.success_message}
					</Alert>
				</Snackbar>
				<ConfirmDialog 
				      confirm_dialog={this.state.cancel_dialog.open} 
				      title={this.state.cancel_dialog.title}
				      message={this.state.cancel_dialog.message}
				      onClose={this.handleDialogClose} 
				      onAccept={this.handleDialogAccept}
				      onCancel={this.handleDialogClose}
				      errors={this.state.cancel_dialog.errors}
				/>

				<ConfirmDialog 
				      confirm_dialog={this.state.delete_dialog.open} 
				      title={this.state.delete_dialog.title}
				      message={this.state.delete_dialog.message}
				      onClose={this.handleDialogClose} 
				      onAccept={this.handleDelete}
				      onCancel={this.handleDialogCancel}
				      errors={this.state.delete_dialog.errors}
				/>
				<ConfirmDialog 
				      confirm_dialog={this.state.dialog.open} 
				      title={this.state.dialog.title}
				      message={this.state.dialog.message}
				      onClose={this.handleDialogClose} 
				      onAccept={this.handleDialogAccept}
				      onCancel={this.handleDialogCancel}
				      errors={this.state.dialog.errors}
				/>
		        <Container fluid className="main-content-container px-4 position-relative">
				<Row noGutters className="page-header">
				  <Typography variant="h6">Plan de mantenimiento</Typography>
				</Row>

				<Row>
				{(this.state.loading)
					?
						''
					:
						<React.Fragment>
							<div className="row col-12 mb-2 mt-2 ml-2">
								<TextField
									id="name"
									name="name"
									margin="normal"
									className="mr-2 mt-1"
									InputLabelProps={{
										shrink: true
									}}
									disabled={this.state.disabled}
					 			  	onChange={this.handleChange}
									value={maintenance_plan.name}
									inputProps={{style:{width: 100, fontSize: '0.75rem'}}}
								  	InputProps={{
								        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Nombre</Typography></InputAdornment>,
									}}
								/>

								<TextField
									id="description"
									name="description"
									margin="normal"
									className="mr-2 mt-1"
									InputLabelProps={{
										shrink: true
									}}
									disabled={this.state.disabled}
					 			  	onChange={this.handleChange}
									value={maintenance_plan.description}
									inputProps={{style:{width: 250, fontSize: '0.75rem'}}}
								  	InputProps={{
								        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Descripción</Typography></InputAdornment>,
									}}
								/>
							</div>
							<div className="row col-12 mb-1 ml-2">
			                  <Typography variant="subtitle1">Tareas</Typography>
							</div>
							{(maintenance_plan.tasks.map((val, idx)=>{
								return (
									<React.Fragment>
										<div className="row col-12 ml-2">
										    {(val.task.id !== '')
										    ?
												<TextField
													id={"task_id."+idx}
													name={"task_id."+idx}
													disabled={true}
													fullWidth
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
									 			  	onChange={this.handleChange}
													value={val.task.task_group + " - " + val.task.task_sub_group + " - "+val.task.name}
													inputProps={{style:{fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Tarea</Typography></InputAdornment>,
													}}
												/>
										    :
											    <Autocomplete
											      id={"tasks."+idx}
											      name={"tasks."+idx}
											      style={{ width: 200}}
												  disabled={this.state.disabled}
											      getOptionLabel={(option) => option.name}
												  getOptionSelected={(option, value) => option.name === value}			      
											      options={this.state.tasks.options}
											      loading={this.state.tasks.loading}
											      onInputChange={this.handleTasksAsyncSearch}
											      onChange={this.handleTasksAsyncChange.bind(this)}
												  //value={this.state.tasks.options.find(v => v.name === this.state.tasks.task.name) || {name:''}}
											      autoComplete
												  noOptionsText={<Typography variant="caption">Sin resultados</Typography>}
											      includeInputInList
											      className="mr-2 mt-1"
											      classes={{
										            option: classes.option, 
								        		  }}
											      renderInput={(params) => (
											        <TextField
											          {...params}
											          placeholder="Ingrese una tarea"
											          InputProps={{
											            ...params.InputProps,
											            endAdornment: (
											              <React.Fragment>
											                {this.state.tasks.loading ? <CircularProgress color="inherit" size={20} /> : null}
											                {params.InputProps.endAdornment}
											              </React.Fragment>
											            ),
											          }}
														InputLabelProps={{ ...params.InputLabelProps,
																			shrink: true
																		}}
														inputProps={{
														            ...params.inputProps,
														            style:{fontSize: '0.75rem', width: 70}
														          }}
											        />
											      )}
											    />
										    }
									    </div>
									    <div className="row col-12 ml-2">
											<Tooltip title={"Se debe realizar la tarea a los " + ((val.up_to_km) ? val.up_to_km : 0) + " km."} arrow>
												<TextField
													id={"up_to_km."+idx}
													name={"up_to_km."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													disabled={this.state.disabled}
													type="number"
									 			  	onChange={this.handleChange}
													value={val.up_to_km}
													inputProps={{style:{width: 60, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >KM</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<Tooltip title={"Se debe realizar la tarea a los " + ((val.months) ? val.months : 0) + " meses."} arrow>
												<TextField
													id={"months."+idx}
													name={"months."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													type="number"
									 			  	onChange={this.handleChange}
													value={val.months}
													disabled={this.state.disabled}
													inputProps={{style:{width: 60, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Meses</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<Tooltip title={"Se debe realizar la tarea cada " + ((val.each_km) ? val.each_km : 0) + " km."} arrow>
												<TextField
													id={"each_km."+idx}
													name={"each_km."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													type="number"
													disabled={this.state.disabled}
									 			  	onChange={this.handleChange}
													value={val.each_km}
													inputProps={{style:{width: 60, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Cada km</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<Tooltip title={"Se debe realizar la tarea cada " + ((val.each_months) ? val.each_months : 0) + " meses."} arrow>
												<TextField
													id={"each_months."+idx}
													name={"each_months."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													type="number"
													disabled={this.state.disabled}
									 			  	onChange={this.handleChange}
													value={val.each_months}
													inputProps={{style:{width: 60, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Cada meses</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<Tooltip title={(val.q_alerts > 0 ) ? "Se enviará 1 alerta y " + (parseInt(val.q_alerts) - 1).toString() + " recordatorios." : ""} arrow>
												<TextField
													id={"q_alerts."+idx}
													name={"q_alerts."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													type="number"
									 			  	onChange={this.handleChange}
													disabled={this.state.disabled}
													value={val.q_alerts}
													inputProps={{style:{width: 30, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Cant. alertas</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<Tooltip title={"La primera alerta se enviará " + ((val.km_before_alerts) ? val.km_before_alerts : 0) + " km antes llegar al vencimiento."} arrow>
												<TextField
													id={"km_before_alerts."+idx}
													name={"km_before_alerts."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													type="number"
													disabled={this.state.disabled}
									 			  	onChange={this.handleChange}
													value={val.km_before_alerts}
													inputProps={{style:{width: 45, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >KMs antes</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<Tooltip title={"La primera alerta se enviará " + ((val.days_before_alerts) ? val.days_before_alerts : 0) + " días antes llegar al vencimiento."} arrow>
												<TextField
													id={"days_before_alerts."+idx}
													name={"days_before_alerts."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													type="number"
													disabled={this.state.disabled}
									 			  	onChange={this.handleChange}
													value={val.days_before_alerts}
													inputProps={{style:{width: 30, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Dias antes</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<Tooltip title={"Se enviará una alerta con " +  (parseInt(val.q_alerts) - 1).toString() + " recordatorios cada "+ ((val.days_between_alert) ? val.days_between_alert : 0) + " días."} arrow>
												<TextField
													id={"days_between_alert."+idx}
													name={"days_between_alert."+idx}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
														shrink: true
													}}
													type="number"
									 			  	onChange={this.handleChange}
													disabled={this.state.disabled}
													value={val.days_between_alert}
													inputProps={{style:{width: 30, fontSize: '0.75rem'}}}
												  	InputProps={{
												        startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Días entre alertas</Typography></InputAdornment>,
													}}
												/>
											</Tooltip>
											<IconButton disabled={disabled} size="small">
												<AddIcon disabled={disabled} onClick={(e)=> {this.handleNewTask(e)}} />
											</IconButton>
											<IconButton disabled={disabled} size="small">
												<RemoveIcon disabled={disabled} onClick={(e) => {this.handleRemoveTask(e,idx)}} />
											</IconButton>
										</div>
									</React.Fragment>
								)
							}))}
						</React.Fragment>
					}
				</Row>
				<Button className="mt-3 mx-1" variant="contained" color="secondary" size="small" style={{fontSize: '0.75rem'}} onClick={this.handleCancelDialog}>Cancelar</Button>
				<Button className="mt-3 mx-1" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={this.handleSubmit}>Guardar</Button>
				</Container>
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(MaintenancePlan);

